import { Button, Container } from "@brightagency/headstart-common";
import React from "react";
import { WPImage, WPLink } from "../../../constants/types";
import { convertToRelativeUrl } from "../../../utils";
import { Outer, Wrapper, Content, Title, Copy, ImageContainer, ButtonContainer } from "./styled";

interface Props {
    topColor?: string;
    bottomColor?: string;
    image?: WPImage;
    title: string;
    description: string;
    button: WPLink;
    removeExtraBottomSpacing?: boolean;
}

export const PullUpSection: React.FC<Props> = props => {
    return (
        <Outer topColor={props.topColor} bottomColor={props.bottomColor}>
            <Container>
                <Wrapper removeExtraBottomSpacing={props.removeExtraBottomSpacing}>
                    { props?.image ?
                        <ImageContainer>
                            <img src={props.image?.url} alt="" />
                        </ImageContainer>
                        : null
                    }
                    <Content className={!props?.image ? 'no-image' : ''}>
                        <Title>{props.title}</Title>
                        <Copy>{props.description}</Copy>
                    </Content>
                    <ButtonContainer>
                        <Button
                            to={convertToRelativeUrl(props.button.url)}
                            target={props.button.target}
                            maxWidth={300}
                        >
                            {props.button.title}
                        </Button>
                    </ButtonContainer>
                </Wrapper>
            </Container>
        </Outer>
    );
};
